import * as React from 'react';

import Fade from '@material-ui/core/Fade';

export class FadeTransition extends React.Component {
  public render() {
    return <Fade {...this.props} />;
  }
}
